(function ($) {
  $(document).ready(function () {
    $(".resource-banner .tabs-wrap .tab").click(function () {
      $(".resource-banner .tabs-wrap .tab, .resource-banner .featured-resource").removeClass("active");
      $(this).addClass("active");
      var tabId = $(this).data("tab");
      $("#" + tabId).addClass("active");
    });
  });
})(jQuery);
